module.exports = __webpack_public_path__ + "static/media/Image.9e19df12.png";